<template>
  <div>
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-card>
        <div class="d-flex justify-content-between">

          <div class="ml-1">
            <b-row>
              <b-button
                variant="warning"
                icon-pack="feather"
                icon="icon-chevron-left"
                @click="$router.go(-1)"
              >Back</b-button>
            </b-row>
            <b-row>
              <b-badge
                pill
                class="mt-1"
                variant="dark"
              >Position : {{ specified_position }}</b-badge>
            </b-row>
            <b-row>
              <b-form-group class="mt-2">
                <b-form-radio-group
                  id="btn-radios-1"
                  v-model="selectedRadio"
                  button-variant="outline-primary"
                  :options="optionsRadio"
                  buttons
                  name="radios-btn-default"
                />
              </b-form-group>
            </b-row>

          </div>
          <div class="flex flex-row items-center">
            <b-dropdown
              v-if="!hide_for_now"
              style="height: 40px;min-width: 180px;"
              split
              variant="dark"
              :text="action_text"
              right
              :icon="action_icon"
              type="filled"
              class="cursor-pointer"
              @click="performAction"
            >

              <b-dropdown-item @click="changeAction('Actions')">
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="InfoIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Actions</span>
                </span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="!$store.state.auth.ActiveUser.email_address.includes('hhqmail')"
                @click="changeAction('Boost Job')"
              >
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="TrendingUpIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Boost Job</span>
                </span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  $store.state.auth.ActiveUser.account_type === $UserGroups.AGENCY
                "
                @click="changeAction('Share with others')"
              >
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="ShareIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Share with others</span>
                </span>
              </b-dropdown-item>

            </b-dropdown>

          </div>
        </div>
        <vue-good-table
          class="my-2"
          style=""
          theme="polar-bear"
          mode="remote"
          :columns="appColumns"
          :rows="applicants"
          :search-options="{
            enabled: false
          }"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"

          :pagination-options="{
            enabled: true,
            perPage: serverParams.perPage,
            perPageDropdown: [5, 10, 20, 50, 100],
            dropdownAllowAll: false,
          }"
          :total-rows="totalRecords"

          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-selected-rows-change="selectionAppChanged"
        >
          <template
            slot="column-filter"
            slot-scope="props"
          >
            <span
              v-if="props.column.field === 'date'"
              class="mt-2"
            >
              <!-- <flat-pickr
                v-model="created_on_filter"
                :config="configPicker"
                class="vgt-input"
                placeholder="Filter Added On"
                @input="(value) => updateFilters(props.column.field, value)"
              /> -->

              <b-button
                variant="warning"
                @click="showDateRangeFilter(true, props.column.field)"
              >
                Click to filter the date
              </b-button>
              <b-button
                v-if="props.column.field in serverParams.columnFilters"
                class="ml-2"
                @click="resetDateRangeFilter(true, props.column.field)"
              >Reset</b-button>
            </span>
          </template>

          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Status -->
            <span v-if="props.column.field === 'fullname'">
              <b-row class="mx-auto">
                <h6 class="my-auto">{{ props.row.fullname }}</h6>
              </b-row>
            </span>

            <span v-else-if="props.column.field === 'email'">
              <b-row class="w-100 ml-1">
                <div
                  v-if="$store.state.auth.ActiveUser.account_type === $UserGroups.AGENCY"
                >
                  <p>{{ props.row.email_address }}</p>
                </div>
                <div v-else>
                  <p
                    v-if="!props.row.mask_email || props.row.mask_email.includes('unmask')"
                  >
                    {{ props.row.email_address }}
                  </p>
                  <p
                    v-else-if="props.row.mask_email.includes('hide')"
                    class="font-bold"
                  >
                    Hidden Info
                  </p>
                  <b-button
                    v-else
                    variant="warning"
                    @click="
                      showInfo(
                        props.row.email,
                        'email',
                        props.row.app_id,
                        props.row.email,
                        props.row.mask_email,
                        $event,
                        (other_info = props.row.alias_email),
                      )
                    "
                  >Email Address
                  </b-button>
                </div>
              </b-row>

            </span>

            <span v-else-if="props.column.field === 'contact'">
              <b-row class="w-100 ml-1">
                <div
                  v-if="$store.state.auth.ActiveUser.account_type === $UserGroups.AGENCY"
                >
                  <p>{{ props.row.phone_number }}</p>
                </div>
                <div v-else>
                  <p
                    v-if="
                      !props.row.mask_contact || props.row.mask_contact.includes('unmask')
                    "
                    class="my-auto"
                  >
                    {{ props.row.phone_number }}
                  </p>
                  <p
                    v-else-if="props.row.mask_contact.includes('hide')"
                    class="font-bold"
                  >
                    Hidden Info
                  </p>
                  <b-button
                    v-else
                    :ref="props.row.phone_number"
                    variant="warning"
                    @click="
                      showInfo(
                        props.row.phone_number,
                        'contact',
                        props.row.app_id,
                        props.row.email,
                        props.row.mask_contact,
                        $event,
                        (other_info = props.row.alias_email),
                      )
                    "
                  >
                    Phone Number
                  </b-button>
                </div>
              </b-row>

            </span>

            <span v-else-if="props.column.field === 'note'">
              <div
                v-if="
                  props.row.note &&
                    props.row.note.length > 0 &&
                    !$store.state.auth.ActiveUser.account_type === $UserGroups.AGENCY
                "
              >
                <b-form-textarea
                  v-model="props.row.note"
                  rows="4"
                  disabled
                />
              </div>
            </span>

            <span v-else-if="props.column.field === 'application_status' || props.column.field === 'internal_status'">
              <b-row
                v-if="!hide_for_now"
                class="w-100 mx-auto"
                style=""
              >
                <!-- <v-select
                  v-model="applicants[props.index][props.column.field]"
                  placeholder="Select the application status"
                  :options="applicant_statuses"
                  label="value"
                  style="width: 280px!important;"
                  :reduce="value => value.value"
                  @input="changeStatus(props.row, applicants[props.index][props.column.field], props.column.field)"
                /> -->

                <select
                  v-model="applicants[props.index][props.column.field]"
                  class="w-100"
                  style="padding: 0.4rem; border-radius: 4px;"
                  @change="changeStatus(props.row, applicants[props.index][props.column.field], props.column.field)"
                >
                  <option
                    :value="null"
                    :selected="true"
                  >Select the application status</option>
                  <option
                    v-for="option in applicant_statuses"
                    :key="option.key"
                    :value="option.value"
                  >
                    <p> {{ option.text }} </p>
                  </option>
                </select>
              </b-row>

            </span>

            <span v-else-if="props.column.field === 'status_reviewed'">
              <div style="width: 373px!important;">

                <b-row
                  class=""
                  style="width: 400px!important;margin-top:-12px;"
                >
                  <b-col
                    cols="4"
                    class="border"
                  >
                    <h6
                      class=""
                      style="padding-top: 10px;padding-bottom:5px;"
                    >View Status</h6>
                  </b-col>

                  <b-col
                    cols="8"
                    class="border"
                  >
                    <h6
                      class=""
                      style="padding-top: 10px;padding-bottom:5px;"
                    >Application Status</h6>
                  </b-col>
                </b-row>

                <b-row
                  class=""
                  style="width: 400px!important;height: 60px!important;margin-bottom:-13px;"
                >
                  <b-col
                    cols="4"
                    class="border"
                  >

                    <b-badge class="mt-2 font-bolder">{{ props.row.status_reviewed && props.row.status_reviewed.split("-")[1] ? "Reviewed" : "Pending" }}</b-badge>
                  </b-col>

                  <b-col
                    cols="8"
                    class="border "
                  >
                    <b-badge class="mt-2 font-bolder">{{ props.row.status_reviewed && props.row.status_reviewed.split("-")[0] }}</b-badge>
                  </b-col>
                </b-row>
              </div>
            </span>

            <span v-else-if="props.column.field === 'view_resume'">

              <!-- <b-button
                variant="primary"
                @click="
                  viewUploadedResume(props.row)
                "
              >View Resume</b-button> -->

              <b-button
                variant="primary"
                @click="
                  downloadResume(
                    props.row.userid,
                    props.row.resume,
                    props.row.app_id,
                    props.row.mask_email,
                    props.row.mask_contact,
                    props.row, applicants[props.index].status, props.column.field
                  )
                "
              >View Resume</b-button>
            </span>

            <span v-else-if="props.column.field === 'view_activity'">
              <b-button
                variant="primary"
                @click="viewActivity(props.row.activity)"
              >View Activity</b-button>
            </span>

            <span v-else-if="props.column.field === 'actions'">

              <b-dropdown
                v-if="!hide_for_now"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="
                    $store.state.auth.ActiveUser.account_type === $UserGroups.AGENCY
                  "
                  @click="singleShare(props.row)"
                >Share with others</b-dropdown-item>
              </b-dropdown>

            </span>
            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template
            v-if="false"
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  Showing 1 to
                </span>
                <b-form-select
                  v-model="itemsPerPage.applicants"
                  :options="['5','10','20', '50', '100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap "> of {{ applicants.length }} entries </span>
              </div>
              <div>
                <b-pagination
                  v-model="skip_page"
                  :value="1"
                  :total-rows="applicants.length"
                  :per-page="itemsPerPage.applicants"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card>
    </b-overlay>
    <b-modal
      v-model="update_popup"
      centered
      hide-footer
      title="Update phone number"
    >
      <div class="sm:vx-row mt-4">
        <h6 class="mb-2 mt-4">
          Phone number
        </h6>
        <vx-input-group class="w-full mb-6">
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span>+65</span>
            </div>
          </template>

          <b-form-input
            v-model="phone_number"
            placeholder="Contact number"
            maxlength="8"
          />
        </vx-input-group>
        <div class="vx-row mx-auto mt-8 w-full">
          <b-button
            class="mx-auto w-full"
            variant="primary"
          >Send confirmation code</b-button>
        </div>
        <h6 class="mb-2 mt-4">
          Confirmation code
        </h6>
        <b-form-input
          v-model="confirmation_code"
          required
          class="w-full"
        />

        <div class="vx-row mx-auto mt-8">
          <b-button
            class="mx-auto w-full"
            variant="primary"
            @click="editNumber"
          >Add phone number</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="popupResume"
      centered
      hide-footer
      size="lg"
      title="Applicant Information"
      style="height: 100%!important"
    >
      <div
        v-if="resume_processing"
        class="p-1 mx-auto"
      >
        <b-row>
          <b-spinner
            class="mx-auto"
            type="grow"
            variant="warning"
            label="Loading..."
          />
        </b-row>
        <b-row class="mt-1">
          <h6 class="mx-auto text-warning">
            We are still processing the applicant's resume. Please check again later.
          </h6>
        </b-row>

      </div>
      <iframe
        v-else
        :src="file_source"
        width="100%"
        style="min-height: 100vh!important;"
        frameborder="0"
      />

    </b-modal>

    <b-modal
      v-model="popupActivity"
      centered
      hide-footer
      size="md"
      title="Application Activity"
    >

      <ul
        v-if="currentActivity.length > 0"
        class="p-1"
      >
        <li
          v-for="(activity, index) in currentActivity"
          :key="index"
          class="p-1"
        >{{ activity }}</li>
      </ul>

      <h6 v-else>
        No Activities
      </h6>

    </b-modal>
    <b-modal
      v-model="popupHiring"
      centered
      hide-footer
      size="md"
      title="Share with others"
    >
      <div
        v-for="(shared, index) in shared_data"
        :key="index"
        class="vx-row mt-4 w-full"
      >
        <b-row class="mx-1">
          <h6>Applicant Name</h6>
          <b-form-input
            v-model="shared.fullname"
            class=""
            placeholder="Applicant Name"
            disabled
          />
          <div class="d-flex w-100 justify-content-between">
            <div class="mt-1">
              <h6>Applied Position</h6>
              <b-form-input
                v-model="shared.applied_position"
                class=""
                placeholder="Applied Position"
                disabled
              />
            </div>

            <div class="mt-1">
              <h6>Applied Company</h6>
              <b-form-input
                v-model="shared.employer"
                class=""
                placeholder="Applied Company"
                disabled
              />
            </div>
          </div>
        </b-row>

        <b-row class="mx-1 mt-1">
          <h6 class="">
            Hiring Manager Email
          </h6>

          <b-form-group
            class="w-100"
            :label-for="shared.hiring_manager_email"
          >

            <b-form-input
              :id="shared.hiring_manager_email"
              v-model="shared.hiring_manager_email"
              :state="validateEmail(shared.hiring_manager_email)"
              class="w-full"
              placeholder="Hiring Manager Email"
            />
            <b-form-invalid-feedback>
              A valid Hiring Manager Email is required.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-row>
        <b-row class="mx-1">
          <h6 class="mb-2 mt-1">
            Note
          </h6>
          <b-form-textarea
            v-model="shared.note"
            class="w-full"
            @change="latest_update(shared.note)"
          />
        </b-row>

        <b-row class="mx-1 mt-1 w-100 mb-1">

          <div class="d-flex justify-content-between w-100 mr-2">

            <b-button
              class=""
              variant="primary"
              @click="
                downloadResume(
                  current_applicant.userid,
                  current_applicant.resume,
                  current_applicant.app_id,
                )
              "
            >
              Preview Resume
            </b-button>

            <b-button
              class=""
              variant="success"
            >
              Replace resume
            </b-button>
          </div>
        </b-row>

        <b-row class="mx-1 mt-2">
          <h6>Applicant email :</h6>
          <b-form-radio
            v-model="shared.mask_email"
            name="mask_email"
            class="mx-2"
            :value="shared.mask_email_mask"
            @change="latest_update()"
          >Mask</b-form-radio>
          <b-form-radio
            v-model="shared.mask_email"
            name="mask_email"
            class="mx-1"
            :value="shared.mask_email_unmask"
            @change="latest_update()"
          >Unmask</b-form-radio>
          <b-form-radio
            v-model="shared.mask_email"
            name="mask_email"
            class="mx-1"
            :value="shared.mask_email_hide"
            @change="latest_update()"
          >Hide</b-form-radio>
        </b-row>

        <b-alert
          v-if="
            getMaskInfo(
              'email',
              shared.mask_email,
              shared.mask_email_mask,
              shared.mask_email_unmask,
              shared.mask_email_hide,
            )
          "
          show
          variant="warning"
          icon-pack="feather"
          icon="icon-info"
          class="p-2"
        >{{
          getMaskInfo(
            'email',
            shared.mask_email,
            shared.mask_email_mask,
            shared.mask_email_unmask,
            shared.mask_email_hide,
          )
        }}
        </b-alert>

        <b-row class="mx-1 mt-2">
          <h6>Applicant number :</h6>
          <b-form-radio
            v-model="shared.mask_contact"
            name="mask_contact"
            class="mx-2"
            :value="shared.mask_contact_mask"
            @change="latest_update()"
          >Mask</b-form-radio>
          <b-form-radio
            v-model="shared.mask_contact"
            name="mask_contact"
            class="mx-1"
            :value="shared.mask_contact_unmask"
            @change="latest_update()"
          >Unmask</b-form-radio>
          <b-form-radio
            v-model="shared.mask_contact"
            name="mask_contact"
            class="mx-1"
            :value="shared.mask_contact_hide"
            @change="latest_update()"
          >Hide</b-form-radio>
        </b-row>
        <b-alert
          v-if="
            getMaskInfo(
              'phone_number',
              shared.mask_contact,
              shared.mask_contact_mask,
              shared.mask_contact_unmask,
              shared.mask_contact_hide,
            )
          "
          show
          variant="warning"
          icon-pack="feather"
          icon="icon-info"
          class="p-2"
        >{{
          getMaskInfo(
            'phone_number',
            shared.mask_contact,
            shared.mask_contact_mask,
            shared.mask_contact_unmask,
            shared.mask_contact_hide,
          )
        }}
        </b-alert>
        <hr v-if="shared_data.length > 1">
      </div>

      <div class="vx-row my-2">
        <b-button
          class="mr-2 w-100"
          variant="warning"
          @click="proceedShare(shared_data)"
        >Proceed to share application</b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="boost_popup"
      centered
      hide-footer
      :title="
        'Receive More Applicants To Your Job' + action_text === 'Boost Jobs'
          ? 's'
          : ''
      "
    >
      <div>
        <div class="vx-row my-4 mx-2">
          <b-card
            class="p-2"
          >
            <b-form-radio
              v-model="app_boost_gurantee"
              name="app_boost_gurantee"
              class="mx-2"
              value="application"
            >By Applications</b-form-radio>
            <div
              v-if="show_options.application"
              class="vx-row ml-2 mt-4"
            >
              <b-alert
                active="true"
                variant="warning"
                icon-pack="feather"
                icon="icon-info"
                class="h-auto"
              >
                <span>Tentatively Around S$0.40 - S$3.00 per application.</span>
              </b-alert>
            </div>
          </b-card>
        </div>

        <div class="vx-row my-4 mx-2">
          <b-card class="p-2 w-full">
            <b-form-radio
              v-model="app_boost_gurantee"
              name="app_boost_gurantee"
              class="mx-2"
              value="guaranteed"
            >By Guaranteed Placements</b-form-radio>
            <div
              v-if="show_options.guaranteed"
              class="vx-row w-full"
            >
              <div class="vx-row my-6 w-full mx-auto">
                <b-form-input
                  v-model="guaranteed_amount"
                  class="w-full ml-6"
                  placeholder="How much are you willing to pay for each placement?"
                />
              </div>

              <div class="vx-row my-6 w-full mx-auto">
                <b-form-input
                  v-model="guaranteed_period"
                  class="w-full ml-6"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  maxlength="8"
                  placeholder="Guaranteed placement period in days"
                />
              </div>
              <div
                v-if="guaranteed_period > 0"
                class="vx-row my-6 w-full mx-auto"
              >
                <b-form-textarea
                  v-model="payment_terms"
                  rows="4"
                  placeholder="Payment terms for the guaranteed placement period"
                  class="w-full ml-6"
                />
              </div>
            </div>
          </b-card>
        </div>
        <div class="x-row w-full my-6">
          <div class="vx-col w-1/2 mx-auto">
            <b-button
              v-if="!$store.state.auth.ActiveUser.email_address.includes('hhqmail')"
              variant="primary"
              class="w-64"
              @click="boostJob"
            >Boost Job{{ action_text === 'Boost Jobs' ? 's' : '' }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="openVerifyPopup"
      centered
      hide-footer
      no-close-on-backdrop
      class="container"
      title="Verify your contact information"
    >
      <ContactVerification
        :input-type="verifyType"
        @close-verification="closeVerification"
      />
    </b-modal>

    <b-modal
      v-model="dateRangeFilter"
      centered
      hide-footer
      title="Choose the desired date range to filter the data"
      class="bg-danger"
      size="lg"
    >
      <v-date-picker
        v-model="startEndDate"
        mode="date"
        :masks="masks"
        color="orange"
        :columns="2"
        is-range
        is-expanded
      />
    </b-modal>

    <b-modal
      v-model="popupInterviewDetailsForm"
      centered
      hide-footer
      no-close-on-backdrop
      class="container"
      title="Interview Details"
    >
      <div class="p-1">
        <h6 class="mb-1">
          Choose interview date and time
        </h6>
        <v-date-picker
          v-model="interview_date_time"
          class="my-1"
          mode="dateTime"
          color="red"
          is-expanded
        />
        <b-form-textarea
          v-model="interview_note"
          rows="4"
          class="w-100"
          placeholder="Please type the interview details here"
        />
        <b-button
          id=""
          class="float-right mt-1"
          variant="primary"
          @click="updateInterview"
        >{{ interviewDetailsLoading ? 'Loading...': 'Submit' }}</b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import { sample, debounce, capitalize } from 'lodash'
import {
  formatDistance, format, add, sub,
} from 'date-fns'
import ContactVerification from '@/components/VerifyContact.vue'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import {
  applicationStatusOptions,
  applicationTypeOptions,
} from '@/constants/datastore'

export default {
  components: {
    VueGoodTable,
    'v-select': vSelect,
    ContactVerification,
    flatPickr,
  },
  data() {
    return {
      selectedRadio: 'applied',
      optionsRadio: [
        { text: 'Applied(0)', value: 'applied' },
        { text: 'Suggested(0)', value: 'suggested' },

      ],
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      configPicker: {
        altInput: true,
        enableTime: false,
      },
      created_on_filter: null,
      totalRecords: 0,

      appColumns: [
      ],
      itemsPerPage: {
        applicants: 5,
      },
      selected_applicants: [],
      phone_number: '',
      update_popup: false,
      confirmation_code: '',
      applicants: [],
      skip: 0,
      skip_page: 1,
      limit: 4,
      hide_for_now: false,
      job_id: null,
      isLoading: false,
      current_employer: null,
      hiring_manager_email: null,
      specified_position: null,

      applicant_statuses: applicationStatusOptions,
      popupResume: false,
      document_type: 'pdf',
      file_source: null,
      verifyType: 'phoneNumber',
      openVerifyPopup: false,
      loadingNumber: false,
      currentActivity: [],
      popupActivity: false,
      resume_processing: false,
      popupHiring: false,
      boost_popup: false,
      shared_data: {},
      job_details: {},

      action_view: 'dark',
      action_text: 'Actions',
      action_icon: 'info_outline',

      guaranteed_amount: '',
      guaranteed_period: 0,
      payment_terms: '',

      app_gurantee: '',
      app_boost_gurantee: '',
      show_options: {
        application: false,
        guaranteed: false,
      },
      phoneGenerationDetails: null,

      startEndDate: null,
      masks: {
        input: 'YYYY-MM-DD',
      },

      dateRangeFilter: false,
      dateRangeField: null,

      popupInterviewDetailsForm: false,
      interviewDetailsRowId: null,

      interview_date_time: null,
      interview_note: null,
    }
  },
  watch: {
    selectedRadio(val) {
      this.appColumns = this.initAppColumns()
      this.getApplicants(val)
    },
    app_gurantee(val) {
      if (val === 'guaranteed') {
        this.show_options.guaranteed = true
        this.show_options.application = false
      } else if (val === 'application') {
        this.show_options.application = true
        this.show_options.guaranteed = false
      }

      const button = document.querySelector(
        '.wizard-footer-right > span > .wizard-btn',
      )
      if (button) {
        button.innerHTML = 'Next'
      }
    },
    app_boost_gurantee(val) {
      if (val === 'guaranteed') {
        this.show_options.guaranteed = true
        this.show_options.application = false
      } else if (val === 'application') {
        this.show_options.application = true
        this.show_options.guaranteed = false
      }

      const button = document.querySelector(
        '.wizard-footer-right > span > .wizard-btn',
      )
      if (button) {
        button.innerHTML = 'Next'
      }
    },

    startEndDate(val) {
      const column = this.dateRangeField

      const startDate = format(val.start, 'yyyy-MM-dd')
      const endDate = format(val.end, 'yyyy-MM-dd')

      const value = { from: startDate, to: endDate }
      this.updateFilters(column, value)
      this.dateRangeFilter = false
    },
  },
  created() {
    this.job_id = this.$route.params.job_id
    this.appColumns = this.initAppColumns()
    this.getApplicants()
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
      this.getApplicants()
    },
    onPageChange(params) {
      const prevSelectedROws = this.selectedRows
      this.updateParams({ page: params.currentPage })
      this.updateParams({ selectedRows: prevSelectedROws })
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
    },
    onSortChange(params) {
      if (params[0]) {
        const fieldName = params[0].field
        const sortDetails = { }
        sortDetails[fieldName] = params[0].type
        this.updateParams({ sort: sortDetails })
      }
    },
    onColumnFilter(params) {
      this.serverParams.page = 1
      this.updateParams(params)
    },
    onSelectionChange(params) {
      this.selectedRows = params.selectedRows
    },
    updateFilters(column, value) {
      const currentFilters = this.serverParams.columnFilters
      currentFilters[column] = value
      this.updateParams({ columnFilters: currentFilters })
    },

    closeVerification(args = null) {
      const { applicationId, text, phone_number } = this.phoneGenerationDetails
      this.generateNumber(applicationId, text, phone_number)
      this.openVerifyPopup = false
    },
    latest_update(val) {
      this.$forceUpdate()
    },
    validateEmail(email) {
      const result = String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )
      return Boolean(result)
    },
    getApplicants(application_type = 'Applied') {
      // this.appColumns = this.initAppColumns()

      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      //   this.changeAction('Actions')

      //   this.applicants = data.applicants
      //   this.applicants.forEach(val => {
      //     this.$watch(() => val, this.handleStatusChange, { deep: true })
      //   })
      this.view_applicants = true
      //   this.toggleDataSidebar(true)
      this.isLoading = true
      this.serverParams.application_type = application_type

      const query = `?params=${JSON.stringify(this.serverParams)}`
      this.$http
        .get(`/api/ats-applicants/${this.job_id}${query}`)
        .then(response => {
          const { success } = response.data
          if (success) {
            this.job_details = response.data.job_details
            this.applicants = response.data.applicants
            this.totalRecords = response.data.total_records
            const suggested = response.data.suggested_applications
            this.current_employer = this.job_details.employer
            this.hiring_manager_email = null
            this.specified_position = this.job_details.position
            this.isLoading = false

            this.optionsRadio = [
              { text: `Applied(${this.totalRecords})`, value: 'applied' },
              { text: `Suggested(${suggested})`, value: 'suggested' },
            ]

            // populate boost job form

            if (this.job_details.is_agm) {
              this.app_boost_gurantee = this.job_details.agm_type
              this.guaranteed_period = this.job_details.agm_details.guaranteed_period
              this.guaranteed_amount = this.job_details.agm_details.estimated_guaranteed
              this.payment_terms = this.job_details.agm_details.payment_terms
            }
          }
        })
        .catch(error => {
          this.isLoading = false
        })
    },
    performAction() {
      if (this.action_text === 'Archive Jobs') {
        if (this.check_rights('delete')) {
          const rows = this.selected_jobs
          if (!rows || !rows.length) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Row Selection.',
                  icon: 'AlertCircleIcon',
                  text: 'Please select at least one row to proceed.',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          } else {
            const selected = this.selected_jobs
            let message = ''
            let count = 1
            for (const item of selected) {
              this.items_deletion.push(item)
              message += `\n${count} - ${item.position}\n`
              count += 1
            }
            this.confirmDeleteRecord(message, 'jobs')
          }
        } else {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Inadequate permission',
                icon: 'AlertCircleIcon',
                text: 'You dont have enough rights to delete the data in this section',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        }
      } else if (this.action_text === 'Post Jobs') {
        // this.reset_form();
        // this.popupActive = true;
        // this.show_bulk = true;
        this.$router.push('/applicant-tracking/edit-job')
      } else if (this.action_text === 'Edit Jobs') {
        this.show_bulk = false
        const rows = this.selected_jobs
        if (!rows || !rows.length) {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Row Selection.',
                icon: 'AlertCircleIcon',
                text: 'Please select at least one row to proceed.',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        } else {
          const selected = this.selected_jobs.length === 1 ? this.selected_jobs[0] : {}

          this.$store.dispatch('auth/createSelectedJob', selected).catch(err => {})
          if (selected !== null) {
            this.$router.push(`/applicant-tracking/edit-job/${selected._id}_${selected.source_from}`)
            // this.$router.push({ name: 'applicant-tracking-system-edit-specific', params: {job_id: selected._id, job: selected } })
          }

          this.title = 'Edit Job'
          this.popupActive = true
          this.action = 'update'
        }
      } else if (this.action_text === 'Repost Jobs') {
        const company = this.$store.state.auth.ActiveUser.company_name
        const rows = this.selected_jobs
        if (!rows || !rows.length) {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Row Selection.',
                icon: 'AlertCircleIcon',
                text: 'Please select at least one row to proceed.',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        } else {
          const repost_array = []
          for (const item of rows) {
            repost_array.push(item._id)
          }
          this.restoreCreds()
          this.$http
            .put(`/api/ats-jobs/${company}`, {
              job_ids: repost_array,
              update_type: 'repost',
            })
            .then(response => {
              const cleaner = response.data
              if (cleaner.success) {
                this.$toast(
                  {
                    component: this.$toastContent,
                    props: {
                      title: 'Repost Update',
                      icon: 'AlertCircleIcon',
                      text: 'The job(s) have been reposted successfully!',
                      variant: 'success',
                    },
                  },
                  { timeout: this.$longestTimeout },
                )
              }
            })
            .catch(error => {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: 'Operation Failed',
                    icon: 'AlertCircleIcon',
                    text: 'Please try again later!',
                    variant: 'danger',
                  },
                },
                { timeout: this.$longestTimeout },
              )
            })
        }
      } else if (this.action_text === 'Add Record') {
        if (this.check_rights('write')) {
          this.popupActive = true
        } else {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Inadequate permission',
                icon: 'AlertCircleIcon',
                text: 'You dont have enough rights to add new data in this section',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        }
      } else if (this.action_text === 'Share with others') {
        this.multiShare()
      } else if (
        this.action_text === 'Boost Jobs'
        || this.action_text === 'Boost Job'
      ) {
        const company = this.$store.state.auth.ActiveUser.company_name
        const rows = this.selected_jobs
        if ((!rows || !rows.length) && this.action_text === 'Boost Jobs') {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Row Selection.',
                icon: 'AlertCircleIcon',
                text: 'Please select at least one row to proceed.',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        } else {
          this.boost_popup = true
        }
      }
    },
    boostJob() {
      const all_data = {
        type: 'jobs',
        job_id: this.job_id,
        boost_type: this.app_boost_gurantee,
        guaranteed_period: this.guaranteed_period,
        guaranteed_amount: this.guaranteed_amount,
        payment_terms: this.payment_terms,
      }

      this.$http
        .put('/api/boost-job', { data: all_data })
        .then(response => {
          const { success } = response.data
          if (success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Event Manager Notification',
                  icon: 'AlertCircleIcon',
                  text: 'Your job has been boosted successfully',
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        })
        .catch(error => { alert('error') })
      this.boost_popup = false
    },
    changeAction(text) {
      this.action_text = text
      switch (text) {
        case 'Post Jobs':
          this.action_view = 'success'
          this.action_icon = 'add'
          break
        case 'Repost Jobs':
          this.action_view = 'primary'
          this.action_icon = 'redo'
          break

        case 'Edit Jobs':
          this.action_view = 'warning'
          this.action_icon = 'edit'
          break

        case 'Archive Jobs':
          this.action_view = 'danger'
          this.action_icon = 'archive'
          break
        case 'Actions':
          this.action_view = 'dark'
          this.action_icon = 'info_outline'
          break
        default:
          this.action_view = 'dark'
          this.action_icon = 'info_outline'
      }

      this.performAction()
    },
    initAppColumns() {
      let allColumns = []
      // eslint-disable-next-line prefer-const

      let hiring_ag_only = []
      let hide_now = []
      if (this.$store.state.auth.ActiveUser.account_type === this.$UserGroups.AGENCY) {
        hiring_ag_only = [{
          label: 'View Activity',
          field: 'view_activity',
          thClass: 'shorterColumnWidth',
        }]
      }

      let applicationType = []
      // if (userInfo.user_group.includes('employer')) {
      if (this.selectedRadio === 'applied') {
        applicationType = [{
          label: 'Application Type',
          field: 'application_type',
          filterOptions: {
            enabled: true,
            placeholder: '',
            trigger: 'enter',
            filterDropdownItems: applicationTypeOptions,
          },
          thClass: 'columnWidth',
        }]
      }
      // }

      let internalStatus = []
      let sharedStatus = []
      let note = []

      if (!this.hide_for_now) {
        hide_now = [{
          label: 'Actions',
          field: 'actions',
        }]
        if (this.$store.state.auth.ActiveUser.account_type === this.$UserGroups.AGENCY) {
          internalStatus = [
            {
              label: 'Internal Status',
              field: 'internal_status',
              filterOptions: {
                enabled: true,
                placeholder: '',
                trigger: 'enter',
              },

              thClass: 'columnWidth',
            },
          ]
          sharedStatus = [
            {
              label: 'Shared Status',
              field: 'status_reviewed',
              filterOptions: {
                enabled: true,
                placeholder: '',
                trigger: 'enter',
              },
              thClass: 'columnWidth',
            },
          ]
        } else {
          let interviewDetails = []
          if (this.selectedRadio === 'applied') {
            interviewDetails = [{
              label: 'Interview Details',
              field: 'interview_note',
              filterOptions: {
                enabled: true,
                placeholder: '',
                trigger: 'enter',
              },

              thClass: 'columnWidth',
            }]
          }
          sharedStatus = [
            {
              label: 'Application Status',
              field: 'application_status',
              filterOptions: {
                enabled: true,
                placeholder: '',
                trigger: 'enter',
                filterDropdownItems: applicationStatusOptions,
              },
              thClass: 'columnWidth',
            },
            ...interviewDetails,
          ]
        }
      } else {
        note = [
          {
            label: 'Note',
            field: 'note',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
            thClass: 'columnWidth',
          },
        ]
      }

      let appliedOn = []

      if (this.selectedRadio === 'applied') {
        appliedOn = [{
          label: 'Applied On',
          field: 'date',
          filterOptions: {
            enabled: true,
            placeholder: '',
            trigger: 'enter',
          },
          // thClass: 'shorterColumnWidth mx-1',
          thClass: 'mx-1',
          width: '320px',
        }]
      }

      allColumns = [
        {
          label: 'Full Name',
          field: 'fullname',
          filterOptions: {
            enabled: true,
            placeholder: '',
            trigger: 'enter',
          },
          thClass: 'columnWidth',
        },
        {
          label: 'Email Address',
          field: 'email_address',
          filterOptions: {
            enabled: true,
            placeholder: '',
            trigger: 'enter',
          },
          thClass: 'columnWidth',
        },
        {
          label: 'Contact',
          field: 'contact',
          filterOptions: {
            enabled: true,
            placeholder: '',
            trigger: 'enter',
          },
          thClass: 'shorterColumnWidth',
        },
        ...note,
        ...internalStatus,
        ...sharedStatus,
        ...applicationType,
        ...appliedOn,

        {
          label: 'View Resume',
          field: 'view_resume',
          thClass: 'shorterColumnWidth',
        },
        ...hiring_ag_only,
        ...hide_now,
      ]

      return allColumns
    },
    selectionAppChanged(params) {
      this.selected_applicants = params.selectedRows
      this.selectedRows = params.selectedRows
    },
    showInfo(
      text,
      textType,
      applicationId,
      email,
      maskType,
      event,
      otherInfo,
    ) {
      const dom = event
      if (textType === 'contact') {
        if (maskType.includes('mask')) {
          const { phone_number, phone_number_verified } = this.$store.state.auth.ActiveUser

          if (phone_number_verified) {
            if (phone_number.toString().length !== 8) {
              this.update_popup = true
            } else {
              this.generateNumber(applicationId, text, phone_number)
              // event.target.innerHTML = number
              // this.onCopy(number)
            }
          } else {
            this.phoneGenerationDetails = { applicationId, text, phone_number }
            this.verifyType = 'phoneNumber'
            this.openVerifyPopup = true
            this.$store.dispatch('auth/getLoggedInUser', { router_app: this.$router.app, publicPage: this.$router.currentRoute.meta.allowAnonymous || null })
          }
        } else if (maskType.includes('unmask')) {
          dom.target.innerHTML = text
          this.onCopy(text)
        } else {
          dom.target.innerHTML = 'Hidden Info'
        }
      } else if (maskType.includes('mask')) {
        dom.target.innerHTML = otherInfo
        this.onCopy(text)
      } else if (maskType === 'unmask') {
        dom.target.innerHTML = text
        this.onCopy(text)
      } else {
        dom.target.innerHTML = 'Hidden Info'
      }

      const allData = { _id: applicationId }
      const { user_group } = this.$store.state.auth.ActiveUser
      if (['temporary'].some(el => user_group.includes(el))) {
        this.$http
          .post(`/api/contacted/${email}`, { data: allData })
          .then(response => {})
          .catch(error => {})
      }
    },

    onCopy(text) {
      this.copyTextToClipboard(text)
      this.$toast(
        {
          component: this.$toastContent,
          props: {
            title: 'Text Copy Alert',
            icon: 'AlertCircleIcon',
            text: 'Text copied successfully!',
            variant: 'success',
          },
        },
        { timeout: 1000 },
      )
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return
      }
      navigator.clipboard.writeText(text).then(
        () => {},
        err => {},
      )
    },
    proceedShare(shared_data) {
      this.popupHiring = false
      this.check_shared(shared_data)
    },
    share_with_employer() {
      const hiring_details = this.shared_data

      const jobType = this.job_id.split('-')[1]
      this.$http
        .post('/api/share-application', {
          data: {
            all_ids: this.application_ids,
            db_id: jobType,
            hiring_details,
          },
        })
        .then(response => {
          const { success } = response.data
          if (success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Job Manager',
                  icon: 'AlertCircleIcon',
                  text: response.data.message,
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )
            this.hiring_manager_email = null
            this.shared_data = []
          } else {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Job Manager',
                  icon: 'AlertCircleIcon',
                  text: 'Could not share the applications with the employer',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        })
        .catch(error => {})
    },
    generateNumber(applicationID, applicantPhoneNumber, employerNumber) {
      const applicantBtn = this.$refs[applicantPhoneNumber]
      applicantBtn.innerHTML = 'Loading...'
      const record = {
        application_id: applicationID,
        applicant_no: `+65${applicantPhoneNumber}`,
        employer_no: `+65${employerNumber}`,
      }
      this.$http
        .post('/api/ats-call', { data: record })
        .then(response => {
          const { success } = response.data
          if (success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Call Generator',
                  icon: 'AlertCircleIcon',
                  text: 'Phone number retrieved successfully',
                  variant: 'success',
                },
              },
              { timeout: 1000 },
            )
            const proxyNumber = sample(['+6531298398', '+6531295937'])
            applicantBtn.innerHTML = sample(['+6531298398', '+6531295937'])
            this.onCopy(proxyNumber)
          } else {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Call Generator',
                  icon: 'AlertCircleIcon',
                  text: 'Could not initiate a phone call. Try again later',
                  variant: 'danger',
                },
              },
              { timeout: 10000 },
            )
            applicantBtn.innerHTML = 'Phone Number'
          }
        })
        .catch(error => {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Call Generator',
                icon: 'AlertCircleIcon',
                text: 'Could not initiate a phone call. Try again later',
                variant: 'danger',
              },
            },
            { timeout: 1000 },
          )
          applicantBtn.innerHTML = 'Phone Number'
        })
      // return '+6535454484'
    },
    editNumber() {
      if (this.phone_number.length !== 8) {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Text Copy Alert',
              icon: 'AlertCircleIcon',
              text: 'Text copied successfully!',
              variant: 'success',
            },
          },
          { timeout: 1000 },
        )
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Invalid Phone Number',
              icon: 'AlertCircleIcon',
              text: 'The phone number that you have filled is invalid.',
              variant: 'danger',
            },
          },
          { timeout: this.$longestTimeout },
        )
      } else {
        this.$http
          .put('/api/user', {
            user: {
              phone_number: this.phone_number,
            },
          })
          .then(response => {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Profile Update',
                  icon: 'AlertCircleIcon',
                  text: 'Your phone number has been updated successfully!',
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )

            this.$store.commit('auth/UPDATE_USER_INFO', response.data)
          })
          .catch(error => {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Profile Update',
                  icon: 'AlertCircleIcon',
                  text: 'Could not update your phone number, please try again later!',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          })
        this.update_popup = false
      }
    },

    updateInterview() {
      this.interviewDetailsLoading = true
      const interviewDetails = {
        interview_date_time: this.interview_date_time,
        interview_note: this.interview_note,
      }

      this.changeStatus({ app_id: this.interviewDetailsRowId }, null, null, null, interviewDetails)
      this.popupInterviewDetailsForm = false
    },
    changeStatus(currentRow, choosenItem, field, resumeReviewed = null, interviewDetails = null) {
      if (choosenItem === 'Pending Interview') {
        this.popupInterviewDetailsForm = true
        this.interviewDetailsRowId = currentRow.app_id

        this.interview_date_time = currentRow.interview_date_time
        this.interview_note = currentRow.interview_note
      }

      const changeData = {
        id: currentRow.app_id,

        ...interviewDetails,
      }

      if (field) {
        changeData[[field]] = choosenItem
      }
      // const changeData = {
      //   app_id: currentRow.app_id,
      //   shared_by: currentRow.shared_by,
      //   status: choosenItem,
      //   resume_reviewed: resumeReviewed,
      //   field,
      // }
      this.$http
        .put(`/api/application-status/${this.$route.name}`, { data: changeData })
        .then(response => {
          const { success, errors } = response.data
          if (success && !resumeReviewed) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'ATS Notification',
                  icon: 'AlertCircleIcon',
                  text: response.data.message,
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }

          if (errors && !resumeReviewed) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'ATS Notification',
                  icon: 'AlertCircleIcon',
                  text: response.data.errors[0],
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
          this.getApplicants()
        })
        .catch(error => {
          if (!resumeReviewed) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'ATS Notification',
                  icon: 'AlertCircleIcon',
                  text: 'Application status update has failed. Try again later.',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        })
    },
    getMaskInfo(mask_type, mask_model, mask, unmask, hide) {
      if (mask_type === 'email') {
        if (mask_model === mask) {
          return 'The receiving party would only be able to contact the Job Seeker via an auto-generated email address. Email address in resume will be shown as "—Masked Email—".'
        }
        if (mask_model == unmask) {
          return 'The receiving party would be able to contact the Job Seeker via his/her email address. Email address in resume will not be masked.'
        }
        if (mask_model === hide) {
          return 'The receiving party would not be able to contact the Job Seeker via his/her email address. Email address in resume will be shown as "—Masked Email—".'
        }
        return ''
      }
      if (mask_type === 'phone_number') {
        if (mask_model === mask) {
          return 'The receiving party would only be able to contact the Job Seeker via an auto-generated masked mobile number. Contact number in resume will be shown as "—Masked Number—".'
        }
        if (mask_model == unmask) {
          return 'The receiving party would be able to contact the Job Seeker via his/her mobile number. Contact number in resume will not be masked.'
        }
        if (mask_model === hide) {
          return 'The receiving party would not be able to contact the Job Seeker via his/her mobile number. Contact number in resume will be shown as "—Masked Number—".'
        }
        return ''
      }
      return ''
    },
    downloadResume(
      userid,
      resume_file,
      application_id,
      mask_email,
      mask_contact,
      currentRow, choosenItem, field,
    ) {
      let query = '?'
      if (mask_email) {
        query += `mask_email=${mask_email}`
      }
      if (mask_contact) {
        if (mask_email) {
          query += `&mask_contact=${mask_contact}`
        } else {
          query += `mask_contact=${mask_contact}`
        }
      }
      // const file_base = 'https://api.headhuntershq.com'
      const fileBase = this.$http.defaults.baseURL
      const firstPart = resume_file.replace('.docx', '').replace('.pdf', '')

      if (query === '?') {
        this.file_source = `${fileBase}/api/view-processed/${firstPart}.html`
      } else {
        this.file_source = `${fileBase}/api/view-processed/${firstPart}.html${query}`
      }

      this.$toast(
        {
          component: this.$toastContent,
          props: {
            title: 'Resume Information',
            icon: 'AlertCircleIcon',
            text: 'Please wait a few seconds while we retrieve the applicant resume.',
            variant: 'success',
          },
        },
        { timeout: this.$longestTimeout },
      )

      this.$http
        .get(this.file_source)
        .then(response => {
          const result = response.data

          if (result.errors) {
            this.resume_processing = true
          } else {
            this.resume_processing = false

            const authGroup = this.$store.state.auth.ActiveUser.user_group
            if (authGroup.includes('employer')) {
              this.changeStatus(currentRow, choosenItem, field, true)
            }
          }
          this.popupResume = true
        })
        .catch(error => {
        })
      // if (resume_file) {
      //   email = resume_file;
      // }
      // let checked = 0;
      // let company = this.$store.state.auth.ActiveUser.company_name;
      // let user_group = this.$store.state.auth.ActiveUser.user_group;
      // if (["temporary"].some((el) => user_group.includes(el))) {
      //   checked = 1;
      // }
      // let all_data = { _id: application_id, checked: checked };
    },
    viewActivity(activity) {
      if (activity) {
        const allActivities = activity.reverse()
        this.currentActivity = allActivities.map(acv => {
          let textType = `${acv.done_by_fullname} has updated the application status.`
          if (acv.type === 'application_reviewed') {
            textType = `${acv.done_by_fullname} has reviewed the resume file.`
          }
          return `${capitalize(formatDistance(new Date(acv.done_on), new Date(), {
            addSuffix: true,
          }))} ~ ${textType}`
        })
        this.popupActivity = true
      } else {
        this.currentActivity = []
        this.popupActivity = true
      }
    },
    singleShare(details) {
      const tr = details
      this.current_applicant = tr
      this.shared_data = {}
      const { hiring_email } = tr
      const application_id = tr.app_id
      tr.note = ''
      tr.mask_email = 'email_unmask_1'
      tr.mask_contact = 'contact_unmask_1'
      tr.employer = this.current_employer
      tr.mask_email_unmask = 'email_unmask_1'
      tr.mask_email_mask = 'email_mask_1'
      tr.mask_email_hide = 'email_hide_1'

      tr.mask_contact_unmask = 'contact_unmask_1'
      tr.mask_contact_mask = 'contact_mask_1'
      tr.mask_contact_hide = 'contact_hide_1'

      tr.employer = this.current_employer
      tr.applied_position = this.job_details.position
      // this.shared_data = {1 : tr};
      // this.shared_data = tr
      this.$set(this.shared_data, 1, tr)
      if (!hiring_email) {
        this.sharing_info = `${tr.fullname} - ${tr.email}`
        this.application_ids = [application_id]
        this.popupHiring = true
      } else {
        this.check_shared()
      }
    },
    check_shared(shared_data) {
      const hiring_manager_emails = []
      for (const item in shared_data) {
        hiring_manager_emails.push(shared_data[item].hiring_manager_email)
      }

      this.$http
        .post('/api/check-shared', {
          data: {
            all_ids: this.application_ids,
            hiring_email: hiring_manager_emails,
          },
        })
        .then(response => {
          const { success } = response.data
          if (success) {
            this.confirmSharing(this.application_ids, hiring_manager_emails)
          } else {
            this.confirmSharing(
              this.application_ids,
              hiring_manager_emails,
              false,
            )
          }
        })
        .catch(error => {})
    },
    confirmSharing(application_id, hiring_manager_emails, normal_share = true) {
      const cleaned_emails = hiring_manager_emails.join(', ')

      if (normal_share) {
        this.$bvModal
          .msgBoxConfirm(
            `You are about to share the following application(s): \n\n ${this.sharing_info}\n\n with ${cleaned_emails}. Do you want to proceed?`,
            {
              title: 'Confirm Application Share',
              size: 'sm',
              okVariant: 'warning',
              okTitle: 'Yes',
              cancelTitle: 'Cancel',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
            },
          )
          .then(value => {
            if (value) {
              this.share_with_employer()
            }
          })
      } else {
        this.$bvModal
          .msgBoxConfirm(
            `You have already shared the following application(s): \n\n ${this.sharing_info}\n\n with ${cleaned_emails}. Do you want to share the appliations once more?`,
            {
              title: 'Confirm Application Share',
              size: 'sm',
              okVariant: 'warning',
              okTitle: 'Yes',
              cancelTitle: 'Cancel',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
            },
          )
          .then(value => {
            if (value) {
              this.share_with_employer()
            }
          })
      }
    },

    multiShare() {
      this.shared_data = {}
      const update_array = []
      const update_text = []
      let index = 1
      const all_applicants = []
      for (const item of this.selected_applicants) {
        const share_text = `${item.fullname} - ${item.email}`
        update_text.push(share_text)
        update_array.push(item.app_id)

        item.mask_email = `email_unmask_${index}`
        item.mask_contact = `contact_unmask_${index}`

        item.mask_email_unmask = `email_unmask_${index}`
        item.mask_email_mask = `email_mask_${index}`
        item.mask_email_hide = `email_hide_${index}`

        item.mask_contact_unmask = `contact_unmask_${index}`
        item.mask_contact_mask = `contact_mask_${index}`
        item.mask_contact_hide = `contact_hide_${index}`
        item.employer = this.current_employer
        item.applied_position = this.job_details.position
        // this.shared_data = item
        this.$set(this.shared_data, index, item)
        all_applicants.push(item)

        index += 1
      }
      if (update_array === undefined || update_array.length === 0) {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Row Selection.',
              icon: 'AlertCircleIcon',
              text: 'Please select at least one row to proceed.',
              variant: 'danger',
            },
          },
          { timeout: this.$longestTimeout },
        )
      } else {
        this.sharing_info = update_text.join('\n')
        this.application_ids = update_array
        if (!this.hiring_manager_email) {
          this.popupHiring = true
        } else {
          this.check_shared()
        }
      }
    },

    async viewUploadedResume(row) {
      // Math.random() is to prevent image being cache and display the previous file, when user upload or changed the resume file
      // ?${Math.random(0, 30000000)}
      const fileUrl = await this.$generateDownloadUrl(`${row.resume}`)
      if (row.resume && row.resume.endsWith('pdf')) {
        this.document_type = 'pdf'
        this.file_source = `${fileUrl}?random=${new Date().getTime()}`
      } else {
        this.document_type = 'docs'
        this.file_source = `https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`
      }
      this.popupResume = true
    },

    showDateRangeFilter(show, field) {
      this.dateRangeFilter = show
      this.dateRangeField = field
    },
    resetDateRangeFilter(show, field) {
      this.dateRangeField = field
      delete this.serverParams.columnFilters[field]
      this.startEndDate = null
      this.updateParams({})
    },
  },
}
</script>
<style lang="scss" >
  .icon-spacing{
  margin-top: 3px;
}
.vs__dropdown-menu{
    position: relative!important;
    z-index: 100!important;
    margin-top: -12.5em!important;
}
.columnWidth{
  min-width: 300px!important;
}

.shorterColumnWidth{
  min-width: 200px!important;
}
</style>
